import { ChartDonut } from '../../Chart'
import { BirdviewAgingChart } from '../BirdviewAgingChart'
import { BirdviewBarsChart } from '../BirdviewBarsChart'
import { BirdviewLineChart } from '../BirdviewLineChart'
import {
  BIRDVIEW_CHART_ACTION_OPTIONS,
  BIRDVIEW_CHART_LABEL_KEY,
  BIRDVIEW_CHART_PERIOD_OPTIONS,
  BirdviewChartType,
  BirdviewKpiUnit,
} from '../DashboardBirdview.constants.charts'
import {
  checkIsBirdviewAvgTimeMetric,
  getBirdviewAgeRangeLabelParams,
} from '../DashboardBirdview.utils.charts'

import {
  checkIsBirdviewRatioMetric,
  checkIsBirdviewStackedBars,
} from './BirdviewChartCard.utils.data'

function getBirdviewChartItems(items, t) {
  return items.map(item => ({
    ...item,
    label: item.labelKey
      ? t(item.labelKey, getBirdviewAgeRangeLabelParams(item))
      : item.label,
  }))
}

function getBirdviewChartValueUnit(metric) {
  return checkIsBirdviewAvgTimeMetric(metric)
    ? BirdviewKpiUnit.Days
    : BirdviewKpiUnit.Count
}

function getBirdviewChartControlOptions(options, t) {
  return options.map(option => ({ ...option, label: t(option.labelKey) }))
}

function getBirdviewChartOption(options, value) {
  return options.find(option => option.value === value)
}

// The metric select exists only where the chart declares its options.
export function getBirdviewChartControls({
  chart,
  metricValue,
  periodValue,
  t,
}) {
  const periodOptions = getBirdviewChartControlOptions(
    BIRDVIEW_CHART_PERIOD_OPTIONS,
    t
  )
  const metricOptions = chart.metricOptions
    ? getBirdviewChartControlOptions(chart.metricOptions, t)
    : null

  return {
    metric: metricOptions
      ? getBirdviewChartOption(metricOptions, metricValue)
      : null,
    metricOptions,
    period: getBirdviewChartOption(periodOptions, periodValue),
    periodOptions,
  }
}

export function getBirdviewNextChartOptionValue(options, value) {
  const index = options.findIndex(option => option.value === value)

  return options[(index + 1) % options.length].value
}

export function getBirdviewChartActions(t) {
  return getBirdviewChartControlOptions(BIRDVIEW_CHART_ACTION_OPTIONS, t)
}

export function getBirdviewChartContent({ chart, data, metric, t }) {
  switch (chart.type) {
    case BirdviewChartType.Aging:
      return (
        <BirdviewAgingChart
          items={getBirdviewChartItems(data.items, t)}
          total={data.total}
        />
      )
    case BirdviewChartType.Bars:
      return (
        <BirdviewBarsChart
          color={chart.color}
          isStacked={checkIsBirdviewStackedBars({
            isStacked: chart.isStacked,
            metric,
          })}
          items={getBirdviewChartItems(data.items, t)}
          note={chart.noteKey ? t(chart.noteKey, { count: data.total }) : null}
          total={data.total}
          valueUnit={getBirdviewChartValueUnit(metric)}
          withShare={!checkIsBirdviewRatioMetric(metric)}
        />
      )
    case BirdviewChartType.Donut:
      return (
        <ChartDonut
          items={getBirdviewChartItems(data.items, t)}
          nameKey={BIRDVIEW_CHART_LABEL_KEY}
          total={data.total}
        />
      )
    case BirdviewChartType.Line:
      return <BirdviewLineChart points={data.items} />
    default:
      return null
  }
}
